import Reveal, { SectionLabel } from "./Reveal";
import { WHATSAPP_URL } from "@/lib/scroll";

const STEPS = [
  "Você chama no WhatsApp e escolhe o melhor horário",
  "Na consulta, conversamos sobre sua história, sua rotina e seus sintomas",
  "Avaliação clínica",
  "Eu te explico o que pode estar causando seus sintomas",
  "Definimos um plano para tratar e observamos seus resultados",
  "Retorno pra acompanhar sua evolução",
];

export default function ComoFunciona() {
  return (
    <section id="consulta" className="bg-olive text-cream py-28 md:py-36">
      <div className="mx-auto max-w-[1240px] px-5 md:px-10">
        <SectionLabel n="04" light>
          Como funciona a consulta
        </SectionLabel>
        <Reveal delay={0.08}>
          <h2 className="mt-8 max-w-3xl font-display font-medium text-[clamp(2.1rem,4.6vw,4rem)] leading-[1.06] tracking-[-0.01em]">
            Do primeiro contato ao <em className="font-serifd italic text-sun">plano de cuidado</em>
          </h2>
        </Reveal>

        <ol className="mt-14 md:mt-20 grid gap-x-16 md:grid-cols-2" data-testid="consulta-steps">
          {STEPS.map((step, i) => (
            <Reveal key={step} delay={0.05 * i} y={22}>
              <li className="flex items-start gap-6 md:gap-8 border-t border-cream/15 py-7 md:py-9">
                <span
                  className={`font-display text-4xl md:text-5xl leading-none ${
                    i % 2 === 0 ? "text-sun" : "text-terra"
                  }`}
                >
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="pt-1 text-lg md:text-xl leading-relaxed text-cream/90 max-w-md">
                  {i === 0 ? (
                    <>
                      Você chama no{" "}
                      <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="consulta-step-whatsapp"
                        className="font-semibold text-sun underline decoration-sun/40 underline-offset-4 transition hover:decoration-sun"
                      >
                        WhatsApp
                      </a>{" "}
                      e escolhe o melhor horário
                    </>
                  ) : (
                    step
                  )}
                </p>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
